import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { Star } from 'lucide-react';

function Testimonials() {
  // Testimonials data with correct image names
  const testimonials = [
    {
      id: 1,
      text: "This is the best food I have ever tasted.",
      name: "John Doe",
      image: "/image/MoreInfoPerson.png"
    },
    {
      id: 2,
      text: "Absolutely delicious! The Christmas special menu is fantastic.",
      name: "Sarah Smith",
      image: "/image/Person 2.png"
    },
    {
      id: 3,
      text: "The quality and taste of the food exceeded my expectations.",
      name: "Mike Johnson",
      image: "/image/Person 3.png"
    },
    {
      id: 4,
      text: "Best restaurant in town! The Pilau Rice is to die for.",
      name: "Emily Brown",
      image: "/image/Person 4.png"
    },
    {
      id: 5,
      text: "Amazing service and even better food! Will come back again.",
      name: "David Wilson",
      image: "/image/Person 5.png"
    },
    {
      id: 6,
      text: "The flavors are incredible. Best dining experience ever!",
      name: "Lisa Anderson",
      image: "/image/Person 6.png"
    }
  ];

  // Splide options with responsive padding
  const splideOptions = {
    type: 'slide',
    perPage: 1,
    perMove: 1,
    gap: '0rem',
    padding: { left: '5%', right: '5%' },
    pagination: false,
    arrows: false,
    drag: true,
    autoplay: true,
    interval: 4000,
    pauseOnHover: true,
    speed: 800,
    rewind: true,
    breakpoints: {
      768: {
        padding: { left: '10%', right: '10%' }
      },
      1024: {
        padding: { left: '15%', right: '15%' }
      }
    }
  };

  return (
    <div id='Testimonials'>
        <div className='mt-12 md:py-16 lg:py-24 py-8 px-4 sm:px-6'>
            <div className='flex flex-col lg:flex-row gap-8 md:gap-12 lg:gap-24 justify-center items-center'>
                {/* Image Section */}
                <div className='w-full lg:w-1/2 flex justify-center'>
                    <div className='bg-[#EDF7F8] flex items-center w-full max-w-md lg:max-w-none' style={{
                      borderRadius: '70px 70px 50px 150px'
                    }}>
                      <div className='bg-gradient-to-t from-[#FFA300] flex justify-center my-auto mx-auto h-[300px] sm:h-[350px] md:h-[400px] lg:h-[500px] xl:h-[82vh] overflow-hidden w-[95%]' style={{
                        borderRadius: '70px 70px 50px 150px'
                      }}>
                        <img 
                          src='/image/Testimonials.png' 
                          alt='happy customer' 
                          className='w-full h-full object-cover'
                        />
                      </div>
                    </div>
                </div>
                
                {/* Content Section */}
                <div className='flex flex-col w-full lg:w-1/2 gap-3 md:gap-4 text-center lg:text-left'>
                      <h1 className='text-[#FFA300] text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-handwriting'>
                        Testimonials
                      </h1>
                      <p className='text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-bold my-2 signika text-[#16B97A]'>
                        What Our Customer Say
                      </p>
                      <p className='text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold alata'>
                        About Us
                      </p>
                      
                      {/* Splide Testimonials Carousel */}
                      <div className="splide mx-auto my-6 md:my-8 w-full">
                        <Splide 
                          options={splideOptions}
                          aria-label="Customer Testimonials"
                        >
                          {testimonials.map((testimonial) => (
                            <SplideSlide key={testimonial.id}>
                              <div className='text-center px-2'>
                                {/* Circular Customer Image */}
                                <div className='w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 mx-auto mb-4 md:mb-6 rounded-full overflow-hidden border-2 sm:border-3 md:border-4 border-[#FFA300]'>
                                  <img 
                                    src={testimonial.image} 
                                    alt={testimonial.name}
                                    className='w-full h-full object-cover'
                                  />
                                </div>
                                
                                {/* Testimonial Text */}
                                <p className='text-gray-600 text-sm sm:text-base md:text-lg lg:text-xl quicksand mb-3 md:mb-4 leading-relaxed px-2'>
                                  "{testimonial.text}"
                                </p>
                                
                                {/* Customer Name */}
                                <p className='font-bold text-base sm:text-lg md:text-xl signika text-gray-800'>
                                  {testimonial.name}
                                </p>
                              </div>
                            </SplideSlide>
                          ))}
                        </Splide>
                      </div>

                      {/* Static Stars */}
                      <div className='flex gap-1 text-gray-500 quicksand justify-center lg:justify-start items-center mt-4 md:mt-6'>
                        {/* Use same size for all screens, or use CSS to control size */}
                        <Star className='text-[#FFA300] fill-[#FFA300] w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6'/>
                        <Star className='text-[#FFA300] fill-[#FFA300] w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6'/>
                        <Star className='text-[#FFA300] fill-[#FFA300] w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6'/>
                        <Star className='text-[#FFA300] fill-[#FFA300] w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6'/>
                        <Star className='text-[#FFA300] fill-[#FFA300] w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6'/>
                        <span className='ml-2 font-semibold text-sm sm:text-base'>Rated 5 stars</span>
                      </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Testimonials